import * as React from 'react'
import Box from '@mui/material/Box'
import VendorUserOpenRfps from 'vendors/vendorUserRequestForProposals/VendorUserOpenRfps'
import VendorUserClosedRfps from 'vendors/vendorUserRequestForProposals/VendorUserClosedRfps'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const VendorUserRequestForProposalsView: React.FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: '672px', ml: 2, mr: 2, mt: 4 }}>
          <Typography sx={{ fontWeight: 'fontWeightLight', fontSize: '32px', mb: 4 }}>
            {t('open-request-for-proposals')}
          </Typography>
          <VendorUserOpenRfps />

          <VendorUserClosedRfps />
        </Box>
      </Box>
    </>
  )
}

export default VendorUserRequestForProposalsView
